import React from "react";
import Slide from "@material-ui/core/Slide";
import createAutoCorrectedDatePipe from "text-mask-addons/dist/createAutoCorrectedDatePipe";

export const dateMask = value => (value ? [/\d/, /\d/, "/", /\d/, /\d/, "/", /\d/, /\d/, /\d/, /\d/] : []);
export const autoCorrectedDatePipe = createAutoCorrectedDatePipe("mm/dd/yyyy");

export const styles = theme => ({
  lightTooltip: {
    boxShadow: theme.shadows[1],
    fontSize: 14
  },
  offWhite: {
    backgroundColor: "#dddddd"
  },
  lightBlue: {
    color: "#000cff"

  }
});
